import { useEffect, useState } from 'react'

// Devuelve la fecha actual y se actualiza sola al pasar las 00:00.
export function useToday(): Date {
  const [today, setToday] = useState(() => new Date())
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>
    const schedule = () => {
      const now = new Date()
      const nextMidnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0,
        0,
        1,
      )
      timeoutId = setTimeout(() => {
        setToday(new Date())
        schedule()
      }, nextMidnight.getTime() - now.getTime())
    }
    schedule()
    const onVisible = () => {
      if (!document.hidden) setToday(new Date())
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])
  return today
}
